
















































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import AgentInfoEdit from '../activity-planner/agent-info-edit.vue';
import DxToolbar from 'devextreme-vue/toolbar'
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxTabPanel } from 'devextreme-vue/tab-panel';
import { SelectOption } from '../../models/SelectOption';
import { Popup } from '@questelservices/common-vue';   
import AnalysisReport from './analysis-report.vue'
import AuditorReport from './auditor-report.vue'
import ClientSetupMain from './client-setup-main.vue'

import DxValidationGroup from 'devextreme-vue/validation-group'
import ValidationGroup from "devextreme/ui/validation_group";
import { DxLoadIndicator } from 'devextreme-vue';

import EmailTemplateEditor from '../fee-sheets/email-template-editor.vue' 
import _ from 'lodash';
import { ClientReportOptionDto } from '@/models/client/ClientReportOptionDto';
import { ClientService } from '@/service/ClientService';
import dialog from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { ClientAgentInfoDto } from '@/models/client-agent/ClientAgentInfoDto';
import { ClientAgentService } from '../../service/ClientAgentService';
import { UserService } from '../../service/UserService';
import { UserDto } from '../../models/UserDto';
import { ClientDetailDto } from '../../models/client/ClientDto';


@Component({
    components: {            
        DxToolbar,
        DxToolbarItem,
        DxTabPanel,
        Popup,
        AnalysisReport,
        EmailTemplateEditor,
        AuditorReport,
        DxLoadIndicator,
        DxValidationGroup,
        AgentInfoEdit,
        ClientSetupMain
    }
})

export default class ClientSetupForm extends Vue {
    public $refs: Vue['$refs'] & {
        validationGroupRef? : ValidationGroup;
    } = {};
    
    @Prop({ default: false })
    showDialog!: boolean;        

    @Prop()
    selectedClient!: SelectOption;

    private get validationGroup() {
        return ((this.$refs.validationGroupRef as ValidationGroup).instance as any); 
    }

    showEmailTemplate: boolean = false;
    formTabs: Array<string> = [
        "Main",
        "Analysis Reports",
        "Auditor Reports"
    ];
    selectedIndex: number = 0;

    get selectedTab() {
        return this.formTabs[this.selectedIndex];
    }

    get popupTitle() {
        if(this.selectedClient != undefined) {
            return `${this.selectedClient.text} Setup`
        }
        else {
            return "Client Setup";
        }            
    }

    get clientId() : Guid {
        return "" + this.selectedClient.value;
    }

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value) {
        this.$emit("hidingClientSetup");
    }


    @Watch("showDialog")
    async onPropertyChanged(value: boolean, oldValue: boolean) {                
        if (value) {
            try {
                this.clientReportOptionModel = await this.clientService.getClientReportOption(this.clientId)
                .then(res => res)
                .catch(err => this.reportDefault())
                this.usersList = await this.userService.getUserList()
                .then(res => res)
                .catch(err => new Array<UserDto>());
                this.clientDetails = await this.clientService.getClientDetails(this.clientId)
                .then(res => res)
                .catch(err => new ClientDetailDto());
            }
            finally {
                this.isLoaded = true;
            }
        }            
    }  

    selectedClientAgentIds : number[] | null = null;
    isLoaded: boolean = false; 
    clientService: ClientService;
    clientAgentService: ClientAgentService;
    clientReportOptionModel: ClientReportOptionDto;
    userService: UserService;
    usersList: Array<UserDto> = [];
    clientDetails: ClientDetailDto = new ClientDetailDto();
    reportDefault() : ClientReportOptionDto  {
        return {
            ClientReportOptionId : '00000000-0000-0000-0000-000000000000',
            ClientId: this.clientId,
            AnalysisTemplateId: undefined,
            AuditorTemplateId: undefined,
            AuditorReportAllInOne: false,
            HighExpenditureWarnings: false,
            HighFeeWarnings: false,
            SplitByGroup:false,
            SplitByResponsibleAttorney: false,
            PotentialSavings: false,
            MatterRunningTotal: false,
            BufferAmount: 0
        }
    }

    constructor() {
        super();       
        this.clientReportOptionModel = this.reportDefault();
        this.clientService = new ClientService();  
        this.clientAgentService = new ClientAgentService();
        this.userService = new UserService();      
    }       
    
    clientAgentInfo: ClientAgentInfoDto = new ClientAgentInfoDto();
    showingAgentInfo = false;
    onEditAgent(data:any) {
        let cAInfo = new ClientAgentInfoDto();

        cAInfo.Agent.AgentId = data.AgentId;
        cAInfo.Agent.AgentName = data.AgentName;
        cAInfo.Client.ClientId = this.clientId;
        cAInfo.Jurisdictions = data.Jurisdictions ? data.Jurisdictions : cAInfo.Jurisdictions;
        cAInfo.AgentEmail = data.AgentEmail;
        cAInfo.UnsetCountries = data.UnsetCountries ? data.UnsetCountries :  cAInfo.UnsetCountries;
        cAInfo.JurisdictionFree = data.JurisdictionFree;
        cAInfo.PrimaryAlias = data.PrimaryAlias ? data.PrimaryAlias : cAInfo.PrimaryAlias;
        cAInfo.AgentCCEmail = data.AgentCCEmail ? data.AgentCCEmail : null;
        cAInfo.ClientAgentId = data.ClientAgentId;
        cAInfo.VendorNumber = data.VendorNumber
        this.clientAgentInfo = cAInfo;
       
        this.showingAgentInfo = true;
    }

    hidingDialog(data: ClientAgentInfoDto | null) {            
        this.showingAgentInfo = false;
        if(data !== null) {
            this.$root.$emit("refresh-client-agent-selection", data);
        }            
    }

    onPopupHidden(e:any) {
        this.isLoaded = false;
        this.selectedIndex = 0;
        this.selectedClientAgentIds = null;
        this.validationGroup.reset();
    }

    async confirmSave() {
        let validate = this.validationGroup.validate();

        if(!validate.isValid || !this.clientId) {
            return;
        }

        let result = await dialog.confirm("Are you sure?", "Confirm Changes");
        
        if(result) {
            await this.updateClientDetails();
        }

        if(result && (this.selectedTab == 'Analysis Reports' || this.selectedTab == 'Auditor Reports')) {
            if(this.clientReportOptionModel.ClientReportOptionId === this.reportDefault().ClientReportOptionId){
                let result = await this.clientService.addClientReportOption(this.clientId, this.clientReportOptionModel)
                    .then(res => true)
                    .catch(err => {
                        notify('Failed to save client report options.', 'error', 3000);
                        return false;
                    });
                
                this.saveClientAgentToReceiveReport(result);
            }
            else{
                let result = await this.clientService.updateClientReportOption(this.clientId, this.clientReportOptionModel)
                    .then(res => true)
                    .catch(err => {
                        notify('Failed to save client report options.', 'error', 3000);
                        return false;
                    })
                
                this.saveClientAgentToReceiveReport(result);
            }
        }
    }

    saveClientAgentToReceiveReport(res: boolean) {
        if(this.selectedClientAgentIds != null && res) {
            this.clientAgentService.setClientAgentToReceiveReport(this.clientId, this.selectedClientAgentIds)
                .then(result => {
                    this.hidingEdit();
                })
                .catch(err=> {
                    notify('Failed to save client agents to receive report.', 'error', 3000);
                })
        } else {
          this.hidingEdit();
        }
    }

    async updateClientDetails() {
        await this.clientService.updateClientDetails(this.clientId, this.clientDetails)
        .then(x=> {
            this.hidingEdit();
            notify('Client details updated.', 'success', 3000);
            return true;
        })
        .catch(x=> {
            notify('Failed to update client.', 'error', 3000);
            return false;
        });
    }

    hidingEdit() {
        this.$emit("hidingClientSetup");
    }        

    onEmailTemplateEditorHidding() {
        this.showEmailTemplate = false;

    }
}
